import { AutoRedeemDialog } from "@memorang/ui/components/AutoRedeem/AutoRedeemDialog";
import { useAutoRedeemDialog } from "../hooks/useAutoRedeemDialog";

const AutoRedeemDialogContainer = () => {
	const {
		visible,
		purchases,
		email,
		redeemStatus,
		selectedProducts,
		redeemedProductsExamName,
		handleSelectProduct,
		handleDismiss,
		handleAction,
	} = useAutoRedeemDialog();

	if (!visible) {
		return null;
	}

	return (
		<AutoRedeemDialog
			visible={visible}
			onDismiss={handleDismiss}
			purchases={purchases}
			email={email}
			redeemStatus={redeemStatus}
			onAction={handleAction}
			selectedProducts={selectedProducts}
			onSelectProduct={handleSelectProduct}
			redeemedProductsExamName={redeemedProductsExamName}
		/>
	);
};

export default AutoRedeemDialogContainer;
